/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disabled no-mixed-spaces-and-tabs */

import { IBEError } from '@common/interfaces/be-error.interface';
import { CustomAxiosResponse } from '@common/interfaces/custom-axios-response.interface';
import { CustomPromise } from '@common/interfaces/custom-promise.interface';
import { IRequestService, requestService } from '@common/services/request.service';
import { formatUrl } from '@common/utils/format-url.util';
import { BE_API_URLS } from '@src/shared/be-api-urls.constant';

const API_SERVER_URL = BE_API_URLS.itemService.apiUrl;

// DON'T REMOVE THIS COMMENTS!!! Code between comments auto-generated
// INSERT START
export enum EOrderPaymentStatus {
    pending = 'pending',
    paid = 'paid',
    payment_failed = 'payment_failed',
    cancelled = 'cancelled',
    refunded = 'refunded',
    partial_refund = 'partial_refund',
}
export enum EDeliveryDay {
    Mon = 'Mon',
    Tue = 'Tue',
    Wed = 'Wed',
    Thu = 'Thu',
    Fri = 'Fri',
    Sat = 'Sat',
    Sun = 'Sun',
}
export enum EItemV1OrderGet_Ordering {
    ascending = 'ascending',
    descending = 'descending',
}
export interface ISubscriptionCreateRequestBody {
    start_date?: number;
    next_delivery_date?: string;
    box_id?: string;
    box_item_price_id?: string;
    metadata?: any;
    shipping_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    cf_safe_place?: string;
    cf_dislikes?: string;
    cf_delivery_configuration_id?: string;
    cf_w3w?: string;
    cf_discount?: string;
    cf_is_customisable?: boolean;
}
export interface ISubscriptionUpdateRequestBody {
    start_date?: number;
    next_delivery_date?: string;
    swap_box_item_price_id?: string;
    swap_box_id?: string;
    metadata?: any;
    shipping_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    cf_safe_place?: string;
    cf_dislikes?: string;
    cf_delivery_configuration_id?: string;
    cf_w3w?: string;
    apply_changes_on_next_renewal?: boolean;
    ecoupon?: string;
}
export interface ISubscriptionAddAddonRequest {
    item_price_id?: string;
    sales_config_id?: string;
    quantity?: number;
    ecoupon?: string;
}
export interface ISubscriptionUpdAddonRequest {
    quantity?: number;
}
export interface ISubscriptionPauseRequestbody {
    pause_start_date?: string;
    pause_end_date?: string;
    duration?: number;
}
export interface ISubscriptionRestoreDeliveriesRequestbody {
    delivery_dates?: Array<string>;
}
export interface IStartDateRequestbody {
    start_date?: number;
    next_delivery_date?: string;
}
export interface IReactivateRequest {
    start_date?: number;
    next_delivery_date?: string;
    cf_discount?: string;
}
export interface IApplyCouponRequest {
    ecoupon?: string;
}
export interface IBoxCustomisationPutRequest {
    product_customisations?: Array<{
        product_code?: string;
        swapped_code?: string;
    }>;
}
export interface IItemPrice {
    id?: string;
    name?: string;
    item_family_id?: string;
    description?: string;
    status?: string;
    external_name?: string;
    pricing_model?: string;
    price?: number;
    period?: number;
    currency_code?: string;
    period_unit?: string;
    free_quantity?: number;
    channel?: string;
    resource_version?: number;
    updated_at?: number;
    created_at?: number;
    is_taxable?: boolean;
    item_type?: string;
    show_description_in_invoices?: boolean;
    show_description_in_quotes?: boolean;
    object?: string;
}
export interface IItemWithPrices {
    id?: string;
    description?: string;
    name?: string;
    status?: string;
    resource_version?: number;
    updated_at?: number;
    item_family_id?: string;
    type?: string;
    is_shippable?: boolean;
    is_giftable?: boolean;
    enabled_for_checkout?: boolean;
    enabled_in_portal?: boolean;
    item_applicability?: string;
    metered?: boolean;
    channel?: string;
    metadata?: {
        price?: string;
        description?: string;
    };
    cf_category?: string;
    cf_imageurl?: string;
    object?: string;
    prices?: Array<IItemPrice>;
}
export interface IItem {
    id?: string;
    description?: string;
    name?: string;
    status?: string;
    resource_version?: number;
    updated_at?: number;
    item_family_id?: string;
    type?: string;
    is_shippable?: boolean;
    is_giftable?: boolean;
    enabled_for_checkout?: boolean;
    enabled_in_portal?: boolean;
    item_applicability?: string;
    metered?: boolean;
    channel?: string;
    metadata?: {
        price?: string;
        description?: string;
    };
    cf_category?: string;
    cf_imageurl?: string;
    object?: string;
    cf_type?: string;
}
export interface ISubscription {
    id?: string;
    billing_period?: number;
    billing_period_unit?: string;
    customer_id?: string;
    status?: string;
    current_term_start?: number;
    current_term_end?: number;
    next_billing_at?: number;
    created_at?: number;
    started_at?: number;
    activated_at?: number;
    updated_at?: number;
    has_scheduled_changes?: boolean;
    channel?: string;
    resource_version?: number;
    deleted?: boolean;
    object?: string;
    currency_code?: string;
    subscription_items?: Array<ISubscriptionItems>;
    shipping_address?: {
        country?: string;
        city?: string;
        line1?: string;
        line2?: string;
        line3?: string;
        zip?: string;
    };
    due_invoices_count?: number;
    mrr?: number;
    exchange_rate?: number;
    base_currency_code?: string;
    meta_data?: {
        box_id?: string;
        box_quantity?: number;
    };
    start_date?: number;
    pause_date?: number;
    resume_date?: number;
    coupon?: ICoupon;
    cf_box_id?: string;
    cf_box_quantity?: number;
    cf_postcode?: string;
    cf_discount?: string;
    cf_dislikes?: string;
    cf_safe_place?: string;
    cf_delivery_configuration_id?: string;
    cf_recurring_notes?: string;
    cf_w3w?: string;
    cf_type?: string;
    cf_is_customisable?: boolean;
    cf_total_relative_volume?: number;
}
export interface ISubscriptionBoxGlobalLimit {
    box_global_limit?: number;
}
export interface ICouponResponse {
    coupon?: ICoupon;
}
export interface ICouponCodeResponse {
    ecoupon?: string;
    coupon_code_status?: string;
    coupon?: ICoupon;
}
export interface ICoupon {
    duration_type?: string;
    item_constraints?: Array<ICouponItemConstraints>;
    name?: string;
    discount_type?: string;
    discount_percentage?: number;
    status?: string;
    object?: string;
    resource_version?: number;
    redemptions?: number;
    invoice_name?: string;
    apply_discount_on?: string;
    apply_on?: string;
    created_at?: number;
    updated_at?: number;
    id?: string;
    discount_amount?: number;
    valid_till?: number;
    currency_code?: string;
    period?: number;
    period_unit?: string;
    max_redemptions?: number;
}
export interface ICouponItemConstraints {
    item_type?: string;
    constraint?: string;
    item_price_ids?: Array<string>;
}
export interface ISubscriptionWithScheduledChanges {
    deleted?: boolean;
    mrr?: number;
    exchange_rate?: number;
    billing_period?: number;
    customer_id?: string;
    activated_at?: number;
    channel?: string;
    has_scheduled_changes?: boolean;
    subscription_items?: Array<ISubscriptionItems>;
    due_invoices_count?: number;
    base_currency_code?: string;
    id?: string;
    billing_period_unit?: string;
    status?: string;
    current_term_end?: number;
    current_term_start?: number;
    created_at?: number;
    object?: string;
    currency_code?: string;
    next_billing_at?: number;
    started_at?: number;
    updated_at?: number;
    resource_version?: number;
    coupon?: ICoupon;
    cf_box_id?: string;
    cf_box_quantity?: number;
    cf_discount?: string;
    cf_dislikes?: string;
    cf_safe_place?: string;
    cf_delivery_configuration_id?: string;
    cf_recurring_notes?: string;
    cf_w3w?: string;
    cf_type?: string;
    cf_is_customisable?: boolean;
    cf_total_relative_volume?: number;
}
export interface ISubscriptionItems {
    item_price_id?: string;
    item_type?: string;
    quantity?: number;
    billing_cycles?: number;
    unit_price?: number;
    amount?: number;
    free_quantity?: number;
    object?: string;
    item?: IItem;
}
export interface ISubscriptionCreateResponse {
    subscription?: ISubscription;
    subscription_with_scheduled_changes?: ISubscriptionWithScheduledChanges;
    shifted_delivery_date?: string;
    last_order?: IOrder;
    active_pauses?: Array<IPause>;
    delivery_configuration?: IDeliveryConfiguration;
    next_invoice?: IOrderEstimateResponse;
}
export interface ISubscriptionWithChangesResponse {
    subscription?: ISubscription;
    subscription_with_scheduled_changes?: ISubscriptionWithScheduledChanges;
    last_order?: IOrder;
    active_pauses?: Array<IPause>;
    delivery_configuration?: IDeliveryConfiguration;
    next_invoice?: IOrderEstimateResponse;
    coupon_message?: string;
}
export interface IOrderEstimateResponse {
    original_amount?: number;
    item_level_discount_amount?: number;
    document_level_discount_amount?: number;
    discount_amount?: number;
    final_amount?: number;
    plan?: IOrderEstimateLineItem;
    delivery_fee?: IOrderEstimateLineItem;
    addons?: Array<IOrderEstimateLineItem>;
    discounts?: Array<{
        object?: string;
        entity_type?: string;
        description?: string;
        amount?: number;
        entity_id?: string;
        discount_percentage?: number;
        discount_type?: string;
    }>;
}
export interface IOrderEstimateLineItem {
    item_price_id?: string;
    entity_type?: string;
    quantity?: number;
    unit_amount?: number;
    original_amount?: number;
    item_level_discount_amount?: number;
    final_amount?: number;
}
export interface IBoxCustomisationResponse {
    id?: string;
    pack_house_id?: string;
    sales_availability_to?: string;
    sales_availability_from?: number;
    created_at?: number;
    updated_at?: number;
    archived?: number;
    box_id?: string;
    box_composition_id?: number;
    box_date?: number;
    default_produce?: Array<{
        name?: string;
        code?: string;
        type?: string;
        vanity_name?: string;
        description?: string;
        image_url?: string;
        unit?: Array<{
            box_id?: string;
            value?: string;
        }>;
        order?: number;
        available_options?: Array<{
            name?: string;
            code?: string;
            type?: string;
            vanity_name?: string;
            description?: string;
            image_url?: string;
            unit?: Array<{
                box_id?: string;
                value?: string;
            }>;
            order?: number;
        }>;
    }>;
    selected_produce?: Array<{
        name?: string;
        code?: string;
        type?: string;
        vanity_name?: string;
        description?: string;
        image_url?: string;
        unit?: Array<{
            box_id?: string;
            value?: string;
        }>;
        id?: string;
        updated_at?: number;
        swapped_produce?: {
            name?: string;
            code?: string;
            type?: string;
            vanity_name?: string;
            description?: string;
            image_url?: string;
            unit?: Array<{
                box_id?: string;
                value?: string;
            }>;
        };
    }>;
}
export interface IItemsList {
    list?: Array<{
        items?: IItemWithPrices;
    }>;
}
export interface ISubscriptionList {
    subscription_list?: Array<{
        subscription?: ISubscription;
        subscription_with_scheduled_changes?: ISubscriptionWithScheduledChanges;
        last_order?: IOrder;
        active_pauses?: Array<IPause>;
        delivery_configuration?: IDeliveryConfiguration;
        next_invoice?: IOrderEstimateResponse;
    }>;
}
export interface ICancelSubscription {
    cancellation_status?: string;
}
export interface IPause {
    id?: string;
    dc_id?: string;
    pause_date?: number;
    resume_date?: number;
    updated_at?: number;
    created_at?: number;
    applied?: number;
    customer_id?: string;
    subscription_id?: string;
}
export interface IPauseResponse {
    pause?: IPause;
}
export interface IPausesResponse {
    pauses?: Array<IPause>;
}
export interface ISpecificOrder {
    order?: IOrder;
}
export interface IInvoicePDFLink {
    download_url?: string;
}
export interface ICancellationPageLink {
    url?: string;
}
export interface IChosenProduce {
    code?: string;
    name?: string;
    quantity?: number;
    default_product?: string;
    updated_at?: number;
}
export interface IOrder {
    order_id?: string;
    order_number?: string;
    dbp_id?: string;
    status?: string;
    payment_status?: EOrderPaymentStatus;
    product_id?: string;
    product_code?: string;
    product?: string;
    price?: number;
    quantity?: number;
    customer_id?: string;
    email?: string;
    sub_total?: number;
    total?: number;
    discount?: number;
    promotional_credits?: number;
    coupon?: string;
    coupon_info?: ICoupon;
    delivery_date?: number;
    delivery_price?: number;
    order_date?: number;
    recurring_notes?: string;
    driver_notes?: string;
    subscription_id?: string;
    customer_first_name?: string;
    customer_last_name?: string;
    billing_address?: string;
    billing_address2?: string;
    billing_city?: string;
    billing_country?: string;
    billing_zip_code?: string;
    shipping_address?: string;
    shipping_address2?: string;
    shipping_city?: string;
    shipping_country?: string;
    shipping_zip_code?: string;
    phone?: string;
    dc_id?: string;
    dc_name?: string;
    total_orders?: number;
    cutoff_day?: number;
    cutoff_time?: string;
    dislikes?: string;
    what3words?: string;
    addons?: Array<IOrderAddons>;
    chosen_produce?: Array<IChosenProduce>;
}
export interface IOrderAddons {
    order_id?: string;
    product_code?: string;
    product_id?: string;
    product?: string;
    price?: number;
    quantity?: number;
}
export interface IOrderList {
    order_list?: Array<IOrder>;
    next_page?: number;
}
export interface IStartDateResponse {
    subscription_id?: string;
    start_date?: number;
}
export interface IExclusion {
    product_name?: string;
    product_code?: string;
}
export interface IExclusionResponse {
    exclusion?: IExclusion;
}
export interface IExclusionList {
    exclusion_list?: Array<IExclusion>;
}
export interface ICancellationFlow {
    id?: string;
    customer_id?: string;
    subscription_id?: string;
    status?: string;
    reason_code?: string;
    clicked_solution_code?: string;
    reason_extra_text?: string;
    feedback_text?: string;
    last_updated_at?: number;
}
export interface ICancellationFlowPostRequest {
    subscription_id?: string;
}
export interface ICancellationFlowPatchRequest {
    status?: string;
    reason_code?: string;
    clicked_solution_code?: string;
    reason_extra_text?: string;
    feedback_text?: string;
}
export interface IDeliveryCost {
    every_week?: number;
    every_other_week?: number;
    every_4_week?: number;
}
export interface IAnnouncementObject {
    message?: string;
    period_start?: number;
    period_end?: number;
}
export interface IDeliveryConfiguration {
    id?: string;
    name?: string;
    active?: boolean;
    hidden?: boolean;
    pack_house_id?: string;
    cutoff_day?: number;
    export_day?: number;
    cutoff_time?: string;
    delivery_day?: EDeliveryDay;
    delivery_time?: string;
    delivery_costs?: IDeliveryCost;
    custom_delivery_date?: string;
    announcement?: IAnnouncementObject;
}
export type TItemV1ItemGetError =
    | ''
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionGetError =
    | ''
    | 'Unauthorized'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError'
    | 'DatabaseError';
export type TItemV1SubscriptionPostError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'SubscriptionCreationError'
    | 'DeliveryConfigurationNotDefined'
    | 'InvalidBoxItemPrice'
    | 'PostcodeNotConnectedToDC'
    | 'CustomerNotFound'
    | 'CustomerVerificationError'
    | 'CustomerSuspended'
    | 'CustomerWithoutPaymentMethod'
    | 'UnavailablePriceFrequencyError'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'CutoffTimePassed'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError'
    | 'DatabaseError';
export type TItemV1SubscriptionIdGetError =
    | ''
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'undefined'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError'
    | 'DatabaseError';
export type TItemV1SubscriptionIdPatchError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'SubscriptionUpdatingError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'UnsupportedSubscriptionStatus'
    | 'UpdatingSubscriptionIsBlocked'
    | 'StartDateInPast'
    | 'UnableToChangeStartDate'
    | 'UnableToDefineDeliveryPeriod'
    | 'DeliveryConfigurationNotDefined'
    | 'InvalidItemPrice'
    | 'PostcodeNotConnectedToDC'
    | 'UnavailablePriceFrequencyError'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError'
    | 'DatabaseError';
export type TItemV1SubscriptionIdDeleteError =
    | ''
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'SubscriptionCancelationError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'OperationBlockedDueToPaymentProcessing'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionIdReactivatePostError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'SubscriptionReactivationError'
    | 'NotCancelledSubscriptionCannotBeReactivated'
    | 'CustomerWithoutPaymentMethod'
    | 'CustomerSuspended'
    | 'InvalidDeliveryConfiguration'
    | 'InvalidBox'
    | 'OperationBlockedDueToOperationCutoff'
    | 'SubscriptionHasUnpaidInvoices'
    | 'CouponApplyingBlocked'
    | 'SubscriptionReactivationFailed'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError'
    | 'DatabaseError';
export type TItemV1SubscriptionIdBoxGlobalLimitGetError =
    | ''
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionIdAddonPostError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'AddonAddingError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'UnsupportedSubscriptionStatus'
    | 'InvalidItemPrice'
    | 'ItemPriceAlreadyInSubscription'
    | 'DeliveryConfigurationNotFoundInSubscription'
    | 'DeliveryConfigurationNotDefined'
    | 'SalesConfigNotFound'
    | 'UnavailableSalesConfig'
    | 'LimitExceeded'
    | 'GlobalLimitExceeded'
    | 'StockReductionError'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionIdAddonIdPatchError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'AddonUpdatingError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'SalesConfigDefinitionError'
    | 'SalesConfigNotFound'
    | 'InvalidItemPrice'
    | 'LimitExceeded'
    | 'GlobalLimitExceeded'
    | 'AvailabilityTimeExceeded'
    | 'StockReductionError'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionIdAddonIdDeleteError =
    | ''
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'AddonDeletingError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'ItemPriceNotInSubscription'
    | 'SalesConfigDefinitionError'
    | 'SalesConfigNotFound'
    | 'InvalidItemPrice'
    | 'AvailabilityTimeExceeded'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1SubscriptionIdBoxCustomisationConfigGetError =
    | ''
    | 'InvalidRequestParams'
    | 'BoxCustomisationNotFoundError'
    | 'BoxCustomisationConfigNotFound'
    | 'DeliveryConfigurationNotFound';
export type TItemV1SubscriptionIdBoxCustomisationConfigIdPutError =
    | ''
    | 'InvalidRequestParams'
    | 'BoxCustomisationNotFoundError'
    | 'BoxCustomisationConfigNotFound'
    | 'DeliveryConfigurationNotFound'
    | 'BoxCustomisationConflictError';
export type TItemV1SubscriptionIdLastOrderGetError = '' | 'Unauthorized' | 'EntityNotFound';
export type TItemV1OrderGetError =
    | ''
    | 'Unauthorized'
    | 'OrderResponseFailed'
    | 'ResourceNotFoundException'
    | 'ResourceInUseException';
export type TItemV1OrderIdGetError =
    | ''
    | 'Unauthorized'
    | 'OrderResponseFailed'
    | 'ResourceNotFoundException'
    | 'ResourceInUseException';
export type TItemV1InvoiceIdGetError = '' | 'Unauthorized' | 'ResourceNotFound';
export type TItemV1SubscriptionIdPausePostError =
    | ''
    | 'Unauthorized'
    | 'PauseV2Conflict'
    | 'ResumeDateShouldBeGreaterThatPauseDate'
    | 'OperationBlockedDueToOperationCutoff'
    | 'UnprocessedSubscriptionStatus'
    | 'PauseDuplicatesExistingOne'
    | 'PauseAlreadyAppliedError'
    | 'PauseCreationError'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'InvalidDeliveryWeekday'
    | 'PauseStartDateCutoffExceeded';
export type TItemV1SubscriptionIdPauseGetError = '' | 'Unauthorized';
export type TItemV1SubscriptionIdPauseIdDeleteError =
    | ''
    | 'Unauthorized'
    | 'PauseNotFound'
    | 'PauseV2DeletionConflict'
    | 'OperationBlockedDueToOperationCutoff';
export type TItemV1SubscriptionIdRestoreDeliveriesPostError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'PauseNotFound'
    | 'PauseV2Conflict'
    | 'ResumeDateShouldBeGreaterThatPauseDate'
    | 'OperationBlockedDueToOperationCutoff'
    | 'UnprocessedSubscriptionStatus'
    | 'PauseDuplicatesExistingOne'
    | 'PauseAlreadyAppliedError'
    | 'PauseCreationError'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'InvalidDeliveryWeekday'
    | 'PauseStartDateCutoffExceeded';
export type TItemV1ExclusionGetError = '' | 'ExclusionCacheError';
export type TItemV1ExclusionIdGetError = '' | 'ExclusionNotFound' | 'ExclusionCacheError';
export type TItemV1SubscriptionIdStartDatePatchError =
    | ''
    | 'InvalidRequestParams'
    | 'Unauthorized'
    | 'SubscriptionUpdatingError'
    | 'OperationBlockedDueToOperationCutoff'
    | 'UnsupportedSubscriptionStatus'
    | 'UpdatingSubscriptionIsBlocked'
    | 'StartDateInPast'
    | 'UnableToChangeStartDate'
    | 'UnableToDefineDeliveryPeriod'
    | 'DeliveryConfigurationNotDefined'
    | 'InvalidItemPrice'
    | 'PostcodeNotConnectedToDC'
    | 'UnavailablePriceFrequencyError'
    | 'DeliveryDayOfTheWeekDoesNotMatchDC'
    | 'DeliveryTimeDoesNotMatchDC'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1CouponApplyPutError =
    | ''
    | 'ApplyCouponInvalidRequestParams'
    | 'InvalidRequestParams'
    | 'PlanNotApplicable'
    | 'AddonsNotApplicable'
    | 'PlanAndAddonsNotApplicable'
    | 'CouponNotFound'
    | 'CouponExpired'
    | 'CouponError'
    | 'SubscriptionNotFound'
    | 'ApplyCouponConflictError'
    | 'SubscriptionAlreadyDiscounted'
    | 'DatabaseError';
export type TItemV1CouponCodeIdGetError =
    | ''
    | 'CouponRequestFailed'
    | 'CouponExpired'
    | 'CouponNotApplicable'
    | 'CouponNotFound'
    | 'CouponError'
    | 'CouponPromoCodeErrorResponse'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1CouponSetIdCouponCodePostError =
    | ''
    | 'EntityNotFound'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1CouponSetIdCouponCodeGetError =
    | ''
    | 'InvalidRequestParams'
    | 'EntityNotFound'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TItemV1CancellationFlowPostError = '' | 'InvalidRequestParams';
export type TItemV1CancellationFlowIdPatchError = '' | 'InvalidRequestParams';
export type TItemV1CbCancellationPageIdGetError =
    | ''
    | 'Unauthorized'
    | 'EntityNotFound'
    | 'ChargebeeRequestFailed'
    | 'ChargebeeInvalidRequestError'
    | 'ChargebeeOperationFailedError';
export type TPartialErrorCodes =
    | TItemV1ItemGetError
    | TItemV1SubscriptionGetError
    | TItemV1SubscriptionPostError
    | TItemV1SubscriptionIdGetError
    | TItemV1SubscriptionIdPatchError
    | TItemV1SubscriptionIdDeleteError
    | TItemV1SubscriptionIdReactivatePostError
    | TItemV1SubscriptionIdBoxGlobalLimitGetError
    | TItemV1SubscriptionIdAddonPostError
    | TItemV1SubscriptionIdAddonIdPatchError
    | TItemV1SubscriptionIdAddonIdDeleteError
    | TItemV1SubscriptionIdBoxCustomisationConfigGetError
    | TItemV1SubscriptionIdBoxCustomisationConfigIdPutError
    | TItemV1SubscriptionIdLastOrderGetError
    | TItemV1OrderGetError
    | TItemV1OrderIdGetError
    | TItemV1InvoiceIdGetError
    | TItemV1SubscriptionIdPausePostError
    | TItemV1SubscriptionIdPauseGetError
    | TItemV1SubscriptionIdPauseIdDeleteError
    | TItemV1SubscriptionIdRestoreDeliveriesPostError
    | TItemV1ExclusionGetError
    | TItemV1ExclusionIdGetError
    | TItemV1SubscriptionIdStartDatePatchError
    | TItemV1CouponApplyPutError
    | TItemV1CouponCodeIdGetError
    | TItemV1CouponSetIdCouponCodePostError
    | TItemV1CouponSetIdCouponCodeGetError
    | TItemV1CancellationFlowPostError
    | TItemV1CancellationFlowIdPatchError
    | TItemV1CbCancellationPageIdGetError
    | '';

export const createApiRequest = (rs: IRequestService) => ({
    // get available items
    itemV1ItemGet: (): CustomPromise<CustomAxiosResponse<IItemsList, TItemV1ItemGetError>, IBEError<TItemV1ItemGetError>> =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/item`)),

    // get active user subscriptions
    itemV1SubscriptionGet: (headers: {
        Authorization?: string;
    }): CustomPromise<
        CustomAxiosResponse<ISubscriptionList, TItemV1SubscriptionGetError>,
        IBEError<TItemV1SubscriptionGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription`), { headers }),

    // create new subscription
    itemV1SubscriptionPost: (
        body: ISubscriptionCreateRequestBody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionCreateResponse, TItemV1SubscriptionPostError>,
        IBEError<TItemV1SubscriptionPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/subscription`), body, { headers }),

    // get certain subscription
    itemV1SubscriptionIdGet: (
        subscription_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdGetError>,
        IBEError<TItemV1SubscriptionIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}`), { headers }),

    // update subscription
    itemV1SubscriptionIdPatch: (
        subscription_id: string,
        body: ISubscriptionUpdateRequestBody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdPatchError>,
        IBEError<TItemV1SubscriptionIdPatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}`), body, { headers }),

    // cancel subscription
    itemV1SubscriptionIdDelete: (
        subscription_id: string,
        query: { reason?: string; reason_text?: string } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ICancelSubscription, TItemV1SubscriptionIdDeleteError>,
        IBEError<TItemV1SubscriptionIdDeleteError>
    > => rs.delete(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}`, query), { headers }),

    // reactivate cancelled subscription
    itemV1SubscriptionIdReactivatePost: (
        subscription_id: string,
        body: IReactivateRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdReactivatePostError>,
        IBEError<TItemV1SubscriptionIdReactivatePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/reactivate`), body, { headers }),

    // get global limit for subscription box
    itemV1SubscriptionIdBoxGlobalLimitGet: (
        subscription_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionBoxGlobalLimit, TItemV1SubscriptionIdBoxGlobalLimitGetError>,
        IBEError<TItemV1SubscriptionIdBoxGlobalLimitGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/box_global_limit`), { headers }),

    // add addon to subscription
    itemV1SubscriptionIdAddonPost: (
        subscription_id: string,
        body: ISubscriptionAddAddonRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdAddonPostError>,
        IBEError<TItemV1SubscriptionIdAddonPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/addon`), body, { headers }),

    // update addon quantity in subscription
    itemV1SubscriptionIdAddonIdPatch: (
        subscription_id: string,
        item_price_id: string,
        body: ISubscriptionUpdAddonRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdAddonIdPatchError>,
        IBEError<TItemV1SubscriptionIdAddonIdPatchError>
    > =>
        rs.patch(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/addon/${item_price_id}`), body, {
            headers,
        }),

    // delete addon from subscription
    itemV1SubscriptionIdAddonIdDelete: (
        subscription_id: string,
        item_price_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1SubscriptionIdAddonIdDeleteError>,
        IBEError<TItemV1SubscriptionIdAddonIdDeleteError>
    > =>
        rs.delete(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/addon/${item_price_id}`), {
            headers,
        }),

    // retrieve box customisation configuration and selections
    itemV1SubscriptionIdBoxCustomisationConfigGet: (
        subscription_id: string,
        query: { delivery_configuration_id?: string; delivery_date?: number } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationResponse, TItemV1SubscriptionIdBoxCustomisationConfigGetError>,
        IBEError<TItemV1SubscriptionIdBoxCustomisationConfigGetError>
    > =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/box_customisation_config`, query), {
            headers,
        }),

    // update box customisation selections
    itemV1SubscriptionIdBoxCustomisationConfigIdPut: (
        subscription_id: string,
        box_customisation_config_id: string,
        body: IBoxCustomisationPutRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IBoxCustomisationResponse, TItemV1SubscriptionIdBoxCustomisationConfigIdPutError>,
        IBEError<TItemV1SubscriptionIdBoxCustomisationConfigIdPutError>
    > =>
        rs.put(
            formatUrl(
                API_SERVER_URL +
                    `/item/api/v1/subscription/${subscription_id}/box_customisation_config/${box_customisation_config_id}`,
            ),
            body,
            { headers },
        ),

    // retrieve last order for subscription
    itemV1SubscriptionIdLastOrderGet: (
        subscription_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISpecificOrder, TItemV1SubscriptionIdLastOrderGetError>,
        IBEError<TItemV1SubscriptionIdLastOrderGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/last_order`), { headers }),

    // get order list
    itemV1OrderGet: (
        query:
            | {
                  limit?: number;
                  page?: number;
                  sort_by?: string;
                  ordering?: EItemV1OrderGet_Ordering;
                  start_date?: number;
                  end_date?: number;
              }
            | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<CustomAxiosResponse<IOrderList, TItemV1OrderGetError>, IBEError<TItemV1OrderGetError>> =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/order`, query), { headers }),

    // get specific order
    itemV1OrderIdGet: (
        order_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<CustomAxiosResponse<ISpecificOrder, TItemV1OrderIdGetError>, IBEError<TItemV1OrderIdGetError>> =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/order/${order_id}`), { headers }),

    // get specific invoice by order ID
    itemV1InvoiceIdGet: (
        order_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<CustomAxiosResponse<IInvoicePDFLink, TItemV1InvoiceIdGetError>, IBEError<TItemV1InvoiceIdGetError>> =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/invoice/${order_id}`), { headers }),

    // create subscription pause
    itemV1SubscriptionIdPausePost: (
        subscription_id: string,
        body: ISubscriptionPauseRequestbody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPauseResponse, TItemV1SubscriptionIdPausePostError>,
        IBEError<TItemV1SubscriptionIdPausePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/pause`), body, { headers }),

    // get subscription pauses, sorted by start date
    itemV1SubscriptionIdPauseGet: (
        subscription_id: string,
        query: { limit?: number } | undefined,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPausesResponse, TItemV1SubscriptionIdPauseGetError>,
        IBEError<TItemV1SubscriptionIdPauseGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/pause`, query), { headers }),

    // delete subscription specific pause
    itemV1SubscriptionIdPauseIdDelete: (
        subscription_id: string,
        pause_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<void, TItemV1SubscriptionIdPauseIdDeleteError>,
        IBEError<TItemV1SubscriptionIdPauseIdDeleteError>
    > =>
        rs.delete(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/pause/${pause_id}`), { headers }),

    // restore deliveries and update pause data
    itemV1SubscriptionIdRestoreDeliveriesPost: (
        subscription_id: string,
        body: ISubscriptionRestoreDeliveriesRequestbody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IPauseResponse, TItemV1SubscriptionIdRestoreDeliveriesPostError>,
        IBEError<TItemV1SubscriptionIdRestoreDeliveriesPostError>
    > =>
        rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/restore-deliveries`), body, {
            headers,
        }),

    // get all exclusions
    itemV1ExclusionGet: (
        query: { limit?: number; page?: number } | undefined,
    ): CustomPromise<CustomAxiosResponse<IExclusionList, TItemV1ExclusionGetError>, IBEError<TItemV1ExclusionGetError>> =>
        rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/exclusion`, query)),

    // get certain exclusion
    itemV1ExclusionIdGet: (
        product_code: string,
    ): CustomPromise<
        CustomAxiosResponse<IExclusionResponse, TItemV1ExclusionIdGetError>,
        IBEError<TItemV1ExclusionIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/exclusion/${product_code}`)),

    // update subscription start date
    itemV1SubscriptionIdStartDatePatch: (
        subscription_id: string,
        body: IStartDateRequestbody,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<IStartDateResponse, TItemV1SubscriptionIdStartDatePatchError>,
        IBEError<TItemV1SubscriptionIdStartDatePatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/item/api/v1/subscription/${subscription_id}/start_date`), body, { headers }),

    // apply Coupon to the cheapest Subscription
    itemV1CouponApplyPut: (
        body: IApplyCouponRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ISubscriptionWithChangesResponse, TItemV1CouponApplyPutError>,
        IBEError<TItemV1CouponApplyPutError>
    > => rs.put(formatUrl(API_SERVER_URL + `/item/api/v1/coupon/apply`), body, { headers }),

    // get specific coupon
    itemV1CouponCodeIdGet: (
        promo_code: string,
    ): CustomPromise<
        CustomAxiosResponse<ICouponResponse, TItemV1CouponCodeIdGetError>,
        IBEError<TItemV1CouponCodeIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/coupon/code/${promo_code}`)),

    // create coupon code
    itemV1CouponSetIdCouponCodePost: (
        coupon_set_type: string,
    ): CustomPromise<
        CustomAxiosResponse<ICouponCodeResponse, TItemV1CouponSetIdCouponCodePostError>,
        IBEError<TItemV1CouponSetIdCouponCodePostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/coupon_set/${coupon_set_type}/coupon_code`)),

    // get specific coupon code
    itemV1CouponSetIdCouponCodeGet: (
        coupon_set_type: string,
    ): CustomPromise<
        CustomAxiosResponse<ICouponCodeResponse, TItemV1CouponSetIdCouponCodeGetError>,
        IBEError<TItemV1CouponSetIdCouponCodeGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/coupon_set/${coupon_set_type}/coupon_code`)),

    itemV1CancellationFlowPost: (
        body: ICancellationFlowPostRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ICancellationFlow, TItemV1CancellationFlowPostError>,
        IBEError<TItemV1CancellationFlowPostError>
    > => rs.post(formatUrl(API_SERVER_URL + `/item/api/v1/cancellation_flow`), body, { headers }),

    itemV1CancellationFlowIdPatch: (
        cancellation_flow_id: string,
        body: ICancellationFlowPatchRequest,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<void, TItemV1CancellationFlowIdPatchError>,
        IBEError<TItemV1CancellationFlowIdPatchError>
    > => rs.patch(formatUrl(API_SERVER_URL + `/item/api/v1/cancellation_flow/${cancellation_flow_id}`), body, { headers }),

    // get cancellation page link
    itemV1CbCancellationPageIdGet: (
        subscription_id: string,
        headers: { Authorization?: string },
    ): CustomPromise<
        CustomAxiosResponse<ICancellationPageLink, TItemV1CbCancellationPageIdGetError>,
        IBEError<TItemV1CbCancellationPageIdGetError>
    > => rs.get(formatUrl(API_SERVER_URL + `/item/api/v1/cb_cancellation_page/${subscription_id}`), { headers }),
});

const URL = {
    itemV1ItemGet: (): string => `/item/api/v1/item`,
    itemV1SubscriptionGet: (): string => `/item/api/v1/subscription`,
    itemV1SubscriptionPost: (): string => `/item/api/v1/subscription`,
    itemV1SubscriptionIdGet: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}`,
    itemV1SubscriptionIdPatch: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}`,
    itemV1SubscriptionIdDelete: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}`,
    itemV1SubscriptionIdReactivatePost: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/reactivate`,
    itemV1SubscriptionIdBoxGlobalLimitGet: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/box_global_limit`,
    itemV1SubscriptionIdAddonPost: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}/addon`,
    itemV1SubscriptionIdAddonIdPatch: (subscription_id: string, item_price_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/addon/${item_price_id}`,
    itemV1SubscriptionIdAddonIdDelete: (subscription_id: string, item_price_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/addon/${item_price_id}`,
    itemV1SubscriptionIdBoxCustomisationConfigGet: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/box_customisation_config`,
    itemV1SubscriptionIdBoxCustomisationConfigIdPut: (
        subscription_id: string,
        box_customisation_config_id: string,
    ): string => `/item/api/v1/subscription/${subscription_id}/box_customisation_config/${box_customisation_config_id}`,
    itemV1SubscriptionIdLastOrderGet: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/last_order`,
    itemV1OrderGet: (): string => `/item/api/v1/order`,
    itemV1OrderIdGet: (order_id: string): string => `/item/api/v1/order/${order_id}`,
    itemV1InvoiceIdGet: (order_id: string): string => `/item/api/v1/invoice/${order_id}`,
    itemV1SubscriptionIdPausePost: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}/pause`,
    itemV1SubscriptionIdPauseGet: (subscription_id: string): string => `/item/api/v1/subscription/${subscription_id}/pause`,
    itemV1SubscriptionIdPauseIdDelete: (subscription_id: string, pause_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/pause/${pause_id}`,
    itemV1SubscriptionIdRestoreDeliveriesPost: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/restore-deliveries`,
    itemV1ExclusionGet: (): string => `/item/api/v1/exclusion`,
    itemV1ExclusionIdGet: (product_code: string): string => `/item/api/v1/exclusion/${product_code}`,
    itemV1SubscriptionIdStartDatePatch: (subscription_id: string): string =>
        `/item/api/v1/subscription/${subscription_id}/start_date`,
    itemV1CouponApplyPut: (): string => `/item/api/v1/coupon/apply`,
    itemV1CouponCodeIdGet: (promo_code: string): string => `/item/api/v1/coupon/code/${promo_code}`,
    itemV1CouponSetIdCouponCodePost: (coupon_set_type: string): string =>
        `/item/api/v1/coupon_set/${coupon_set_type}/coupon_code`,
    itemV1CouponSetIdCouponCodeGet: (coupon_set_type: string): string =>
        `/item/api/v1/coupon_set/${coupon_set_type}/coupon_code`,
    itemV1CancellationFlowPost: (): string => `/item/api/v1/cancellation_flow`,
    itemV1CancellationFlowIdPatch: (cancellation_flow_id: string): string =>
        `/item/api/v1/cancellation_flow/${cancellation_flow_id}`,
    itemV1CbCancellationPageIdGet: (subscription_id: string): string =>
        `/item/api/v1/cb_cancellation_page/${subscription_id}`,
};
// INSERT END
// DON'T REMOVE THIS COMMENTS!!!

export const itemApiRequest = {
    ...createApiRequest(requestService),
};
export const ITEM_API_URL = URL;
export type IItemApiRequest = Partial<typeof itemApiRequest>;
